import React from "react";
import useAiFeatures, {aiHref} from "./useAiFeatures";
export default function AiEntries({variant="menu"}){
  const access=useAiFeatures();
  if(access.status!=="ready"||!access.enabled||!access.agent_workspace)return null;
  const items=variant==="header"?[["contracts","Contracts"],["compliance","Compliance"]]:[["contracts","Contracts"],["compliance","Compliance"],["insights","Insights"]];
  items.push(["search","Search all"]);
  return <nav aria-label={variant==="tiles"?"AI workspaces":"AI navigation"} style={{display:"flex",flexWrap:"wrap",gap:16,padding:16}}>{items.map(([route,label])=>aiHref(route)&&<a key={route} href={aiHref(route)} style={{padding:variant==="tiles"?24:8,border:"1px solid #cbd5e1",borderRadius:8,color:"#18385f",background:"white",textDecoration:"none"}}>{label} <small>NEW</small></a>)}</nav>;
}
